export default {
  Customers: 'Customers',
  CreateCustomer: 'CreateCustomer',
  EditCustomer: 'EditCustomer',
  ShowCustomer: 'ShowCustomer'
}
